import React, { useState,useContext } from 'react';
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Col, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../../../LanguageContext';

export default function Newsletter() {
    const {language, setLanguage} = useContext(LanguageContext);
    const events = [
        // {
        //     title: 'Volume 7, Issue 1',
        //     titleHi: 'खंड 7, अंक 1',
        //     link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_July_Dec_2023_Volume_7.pdf',
        //     img: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_July_Dec_2023_Volume_7.png',
        //     dt: 'Jul-Dec', dtHi: 'जुलाई-दिसम्बर',
        //     my: '2023',
        // },
        {
            title: 'Volume 8, Issue 2',
            titleHi: 'खंड 8, अंक 2',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_July_2025_Volume_8.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_July_2025_Volume_8.png',
            dt: 'Jul', dtHi: 'जुलाई',
            my: '2025',
        },
        {
            title: 'Volume 8, Issue 1',
            titleHi: 'खंड 8, अंक 1',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_Jan_2025_Volume_8.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_Jan_2025_Volume_8.png',
            dt: 'Jan', dtHi: 'जनवरी',
            my: '2025',
        },
        {
            title: 'Volume 7, Issue 2',
            titleHi: 'खंड 7, अंक 2',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_July_2024_Volume_7.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_July_2024_Volume_7.png',
            dt: 'Jul', dtHi: 'जुलाई',
            my: '2024',
        },
        {
            title: 'Volume 7, Issue 1',
            titleHi: 'खंड 7, अंक 1',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_Jan_2024_Volume_7.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_Jan_2024_Volume_7.png',
            dt: 'Jan', dtHi: 'जनवरी',
            my: '2024',
        },
        {
            title: 'Volume 6, Issue 2',
            titleHi: 'खंड 6, अंक 2',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_July_2023_Volume_6.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid_July_2023_Volume_6.png',
            dt: 'Jul', dtHi: 'जुलाई',
            my: '2023',
        },
        {
            title: 'Volume 6, Issue 1',
            titleHi: 'खंड 6, अंक 1',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid%20January%202023%20Vol%201.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid January 2023 Vol 1.png',
            dt: 'Jan', dtHi: 'जनवरी',
            my: '2023',
        },
        {
            title: 'Volume 5, Issue 2',
            titleHi: 'खंड 5, अंक 2',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid%20Vol%205,%20Issue%202.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/volume5issue2.png',
            dt: 'Jul', dtHi: 'जुलाई',
            my: '2022',
        },
        {
            title: 'Volume 5, Issue 1',
            titleHi: 'खंड 5, अंक 1',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid%20Vol%205,%20Issue%201.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/volume5issue1.png',
            dt: 'Jan', dtHi: 'जनवरी',
            my: '2022',
        },
        {
            title: 'Volume 4, Issue 2',
            titleHi: 'खंड 4, अंक 2',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid Vol - 4, Issue - 2, July 2021.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/samvidvol4issue2.png',
            dt: 'Jul', dtHi: 'जुलाई',
            my: '2021',
        },
        {
            title: 'Volume 4, Issue 1',
            titleHi: 'खंड 4, अंक 1',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/IIT%20Newsletter%20Jan%202021.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/vol4newsletter.png',
            dt: 'Jan', dtHi: 'जनवरी',
            my: '2021',
        },
        {
            title: 'Volume 3, Issue 2',
            titleHi: 'खंड 3, अंक 2',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/SamvidVol%203issue22020.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/july2020.png',
            dt: 'Jul', dtHi: 'जुलाई',
            my: '2020',
        },
        {
            title: 'Volume 3, Issue 1',
            titleHi: 'खंड 3, अंक 1',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/SamvidJan2020.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/samvidjan2020.png',
            dt: 'Jan', dtHi: 'जनवरी',
            my: '2020',
        },
        {
            title: 'Volume 2, Issue 2',
            titleHi: 'खंड 2, अंक 2',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid%20July%202019.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/samvidjuly2019.png',
            dt: 'Jul', dtHi: 'जुलाई',
            my: '2019',
        },
        {
            title: 'Volume 2, Issue 1',
            titleHi: 'खंड 2, अंक 1',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/SamvidJan2019.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/samvidjan2019-1.png',
            dt: 'Jan', dtHi: 'जनवरी',
            my: '2019',
        },
        {
            title: 'Volume 1, Issue 2',
            titleHi: 'खंड 1, अंक 2',
            link: 'https://files.iittp.ac.in/pdfs/newsletter/Samvid2ndissue.pdf',
            img: 'https://files.iittp.ac.in/pdfs/newsletter/samvid.png',
            dt: 'Jul', dtHi: 'जुलाई',
            my: '2018',
        },
        {
            title: 'Volume 1, Issue 1',
            titleHi: 'खंड 1, अंक 1',
            link: 'https://files.iittp.ac.in/images/demo/iit/pdfs/2018/Newsletter/NewsLetter-Jan2018.pdf',
            img: 'https://files.iittp.ac.in/images/demo/iit/Other/newsletterjan2018.png',
            dt: 'Jan', dtHi: 'जनवरी',
            my: '2018',
        },
    ];

    const handleClick = (index) => {
        window.open(events[index].link, '_blank');
    }

    return (
        <>
            <Header />
            <Breadcrumb title="Home"  titleHi='मुख्य पृष्ठ' subtitle="Newsletter" subtitleHi="समाचारपत्र"/>
            <section className="event pt-80 pb-90 p-relative fix" style={{ backgroundColor: '#cbeef9' }}>
                
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated"
                                data-animation="fadeInDown"
                                data-delay=".4s">
                                <h2>{language==='en'? 'Newsletter': 'समाचारपत्र'}</h2>
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        {events.map((event, index) => (
                            
                            <div key={index} className="col-lg-6 col-md-6  wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <a href={event.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                    <div className="event-item mb-30 hover-zoomin">
                                        <div className="thumb">
                                            <img src={event.img} alt="contact-bg-an-01" />
                                        </div>
                                        <div className="event-content">
                                            <div className="date">
                                                <strong>{language==='en'? event.dt : event.dtHi}</strong> {event.my}
                                            </div>
                                            <h3 style={{ minHeight: "87px" }}>
                                                {" "}
                                                {language==='en'? event.title : event.titleHi}
                                            </h3>
                                        </div>
                                    </div>
                                </a>
                            </div>

                        ))}

                    </div>

                </div>
            </section>
        </>
    )
}